'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_a2a4272b = {"container":"Sorter_module_container__04ae5f19","icon-sort":"Sorter_module_iconSort__04ae5f19","sort-asc":"Sorter_module_sortAsc__04ae5f19","sort-desc":"Sorter_module_sortDesc__04ae5f19","fill":"Sorter_module_fill__04ae5f19"};
require("../../../assets/cjs/components/Table/src/Sorter~Bmt21H4j.css");

exports.default = modules_a2a4272b;
//# sourceMappingURL=Sorter.module.less.js.map
